import React from "react";
import obligee from "./obligeeIcon.svg";
import styled from "styled-components";

const ObligeeIcon = ({ width, height, isMobile }) => {
  return (
    <StyledImg
      width={width || "106"}
      height={height || "112"}
      src={obligee}
      isMobile={isMobile}
    />
  );
};

export default ObligeeIcon;

const StyledImg = styled.img`
  ${(props) => (props.isMobile ? "margin-bottom: 4px; margin-top: 8px;" : "")}
`;
